export default function QuoteForm() {
  return (
    <section id="contacto" className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="reveal">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-bold tracking-wide uppercase mb-4">
            Cotización gratuita
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 leading-tight">
            Solicita tu diagnóstico sin costo y sin compromiso
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
            Contáctanos y nuestro equipo de ingenieros te responderá en menos de 2 horas. Atendemos proyectos en Bogotá y toda Colombia.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto mb-10 items-stretch">
            {/* Dirección */}
            <div className="group flex flex-col items-center gap-4 p-6 rounded-2xl bg-background-100 border border-background-200/70 h-full hover:border-primary-300 transition-colors duration-300">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center">
                <i className="ri-map-pin-line text-background-50 text-xl" />
              </div>
              <div className="text-center">
                <div className="font-heading font-bold text-foreground-950 text-sm mb-1">Dirección</div>
                <div className="text-foreground-600 text-sm leading-relaxed">Cll 70A #16 - 49 Bogotá D.C.</div>
              </div>
              <div className="w-full h-36 rounded-xl overflow-hidden border border-background-200/70">
                <iframe
                  title="Mapa de SERIN Ingeniería de Proyectos - Cll 70A #16 - 49 Bogotá D.C."
                  src="https://www.google.com/maps?q=Cll%2070A%20%2316%20-%2049%20Bogot%C3%A1%20D.C.&output=embed"
                  className="w-full h-full"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </div>
              <a
                href="https://www.google.com/maps/search/?api=1&query=Cll%2070A%20%2316%20-%2049%20Bogot%C3%A1%20D.C."
                target="_blank"
                rel="noopener noreferrer"
                className="mt-auto inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium hover:underline whitespace-nowrap"
              >
                <i className="ri-external-link-line text-sm" />
                Cómo llegar
              </a>
            </div>
            {/* Teléfono / WhatsApp */}
            <div className="group flex flex-col items-center justify-center gap-4 p-6 rounded-2xl bg-background-100 border border-background-200/70 h-full hover:border-primary-300 transition-colors duration-300">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center">
                <i className="ri-phone-line text-background-50 text-xl" />
              </div>
              <div className="text-center">
                <div className="font-heading font-bold text-foreground-950 text-sm mb-1">Teléfono / WhatsApp</div>
                <div className="flex flex-col items-center gap-1.5">
                  <a
                    href="https://wa.me/573232209100"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium hover:underline whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-sm" />
                    323 220 9100
                  </a>
                  <a
                    href="https://wa.me/573505888898"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium hover:underline whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-sm" />
                    350 588 8898
                  </a>
                </div>
              </div>
              <a
                href="https://wa.me/573232209100"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-secondary-100 text-secondary-900 text-sm font-semibold hover:bg-secondary-200 transition-colors whitespace-nowrap"
              >
                <i className="ri-chat-3-line text-sm" />
                Escríbenos ya
              </a>
            </div>
            {/* Correo electrónico */}
            <div className="group flex flex-col items-center justify-center gap-4 p-6 rounded-2xl bg-background-100 border border-background-200/70 h-full hover:border-primary-300 transition-colors duration-300">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center">
                <i className="ri-mail-line text-background-50 text-xl" />
              </div>
              <div className="text-center">
                <div className="font-heading font-bold text-foreground-950 text-sm mb-1">Correo electrónico</div>
                <div className="flex flex-col items-center gap-1.5">
                  <a
                    href="mailto:ventas@serin.com.co"
                    className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium hover:underline break-all leading-snug"
                  >
                    <i className="ri-mail-send-line text-sm" />
                    ventas@serin.com.co
                  </a>
                  <a
                    href="mailto:ingenieria@serin.com.co"
                    className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium hover:underline break-all leading-snug"
                  >
                    <i className="ri-mail-send-line text-sm" />
                    ingenieria@serin.com.co
                  </a>
                </div>
              </div>
              <a
                href="mailto:ventas@serin.com.co"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-secondary-100 text-secondary-900 text-sm font-semibold hover:bg-secondary-200 transition-colors whitespace-nowrap"
              >
                <i className="ri-send-plane-line text-sm" />
                Enviar correo
              </a>
            </div>
          </div>

          <a
            href="https://wa.me/573232209100"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap shadow-lg shadow-accent-500/20"
          >
            <i className="ri-whatsapp-line text-lg w-5 h-5 flex items-center justify-center" />
            Escribir por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}